var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesactiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.08337 16.6667C2.08337 13.7205 2.08337 12.2474 2.99867 11.3321C3.91396 10.4167 5.38709 10.4167 8.33337 10.4167H16.6667C19.613 10.4167 21.0861 10.4167 22.0014 11.3321C22.9167 12.2474 22.9167 13.7205 22.9167 16.6667C22.9167 19.613 22.9167 21.0861 22.0014 22.0014C21.0861 22.9167 19.613 22.9167 16.6667 22.9167H8.33337C5.38709 22.9167 3.91396 22.9167 2.99867 22.0014C2.08337 21.0861 2.08337 19.613 2.08337 16.6667Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 18.75C13.6507 18.75 14.5834 17.8173 14.5834 16.6667C14.5834 15.5161 13.6507 14.5834 12.5001 14.5834C11.3495 14.5834 10.4167 15.5161 10.4167 16.6667C10.4167 17.8173 11.3495 18.75 12.5001 18.75Z",
    fill: "#7D7D7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 8.33337C7.03125 5.31307 9.4797 2.86462 12.5 2.86462C15.0472 2.86462 17.1894 4.60673 17.7965 6.9656C17.9041 7.38346 18.33 7.63501 18.7478 7.52747C19.1657 7.41992 19.4172 6.994 19.3097 6.57614C18.5292 3.54369 15.7774 1.30212 12.5 1.30212C8.61675 1.30212 5.46875 4.45012 5.46875 8.33337V10.4736C5.92345 10.4396 6.44025 10.426 7.03125 10.4205V8.33337Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesactiver);
export default __webpack_public_path__ + "static/media/desactiver.ada1e06d4ffc50b603cae4c4f79c594c.svg";
export { ForwardRef as ReactComponent };